import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

import {
  AdditionalOptionsWrapper,
  AdditionalOption,
} from './SearchAdditionalOptionsWrapper';

const AlreadyFilteredHeader = styled.div`
  font-size: 14px;
  text-align: center;
`;

import { generateURLPath, formatLocation } from '../helpers';

export default function FilterByTags({
  tags = {},
  type,
  country,
  area_level_1,
  currentFilter = false,
}) {
  const tagsArr = Object.keys(tags);
  if (!tags || tagsArr.length < 1) {
    return null;
  }
  if (currentFilter) {
    const title = `${currentFilter} Wedding Transport Hire in ${formatLocation(
      country,
      area_level_1
    )}`;
    return (
      <AlreadyFilteredHeader>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <h1>{title}</h1>
        <AdditionalOption
          href={generateURLPath({
            type,
            area_level_1,
            area_level_2: 'all',
          })}
        >
          View All
        </AdditionalOption>
      </AlreadyFilteredHeader>
    );
  }
  return (
    <AdditionalOptionsWrapper>
      <h4>Refine your search</h4>
      {tagsArr.map(tag => {
        return (
          <AdditionalOption
            key={tag}
            href={generateURLPath({
              type,
              area_level_1,
              area_level_2: 'all',
              tag,
            })}
          >
            {tag}
          </AdditionalOption>
        );
      })}
    </AdditionalOptionsWrapper>
  );
}
